import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Skeleton,
} from "@mui/material";
import axios from "axios";
import {
  FormLabel,
  ModalError,
  ModalSuccess,
  PrimaryButton,
  SecondaryButton,
  TextInput,
} from "components";
import { useEffect, useState } from "react";
import { hardBaseUrl } from "services/urlConstant";
import { getErrors } from "utils";

const ModalFormCurrency = ({ open, onClose, preload, getDataTable }) => {
  const token = localStorage.getItem("token");
  const headers = {
    Authorization: `Bearer ${token}`,
  };
  const [loadingPage, setLoadingPage] = useState(false);
  const [loadingButton, setLoadingButton] = useState(false);
  const [payload, setPayload] = useState({
    currency_iso_code: "",
    currency_name: "",
    currency_symbol_code: "",
    description: "",
  });

  const handleChangePayload = (value, key) => {
    setPayload(currentState => ({
      ...currentState,
      [key]: value,
    }));
  };

  const getDetail = async () => {
    try {
      setLoadingPage(true);
      const res = await axios.get(`${hardBaseUrl}/currency/detail/${preload}`, {
        headers,
      });
      setPayload(res?.data?.data);
    } catch (error) {
      ModalError(getErrors(error?.response));
    } finally {
      setLoadingPage(false);
    }
  };
  const handleSubmit = async () => {
    const method = preload ? axios.put : axios.post;

    try {
      setLoadingButton(true);
      await method(
        `${hardBaseUrl}/currency/${preload ? `update/${preload}` : "create"}`,
        payload,
        { headers }
      );
      onClose();
      ModalSuccess(
        `Successfully ${preload ? "update" : "create"} currency`
      ).then(() => {
        getDataTable();
      });
    } catch (error) {
      console.log({ error });
      ModalError(getErrors(error?.response));
    } finally {
      setLoadingButton(false);
    }
  };

  useEffect(() => {
    if (preload) getDetail();
  }, [preload]);

  return (
    <Dialog fullWidth open={open} onClose={onClose}>
      <DialogTitle>{`${preload ? "Edit" : "Add"} Currency`}</DialogTitle>
      <DialogContent dividers>
        {loadingPage ? (
          <Grid container direction="column" rowSpacing={2}>
            {Array.from({ length: 5 }).map((_, index) => (
              <Grid item key={index}>
                <Box mb="8px">
                  <Skeleton variant="rounded" width="40%" height={25} />
                </Box>
                <Skeleton variant="rounded" width="100%" height={30} />
              </Grid>
            ))}
          </Grid>
        ) : (
          <Grid container direction="column" rowSpacing={1}>
            <Grid item>
              <FormLabel label="Currency Code" required />
              <TextInput
                value={payload?.currency_iso_code}
                onChange={e =>
                  handleChangePayload(e?.target?.value, "currency_iso_code")
                }
                placeholder="Currency Code"
              />
            </Grid>
            <Grid item>
              <FormLabel label="Currency Name" required />
              <TextInput
                value={payload?.currency_name}
                onChange={e =>
                  handleChangePayload(e?.target?.value, "currency_name")
                }
                placeholder="Currency Name"
              />
            </Grid>
            <Grid item>
              <FormLabel label="Currency Symbol Code" required />
              <TextInput
                value={payload?.currency_symbol_code}
                onChange={e =>
                  handleChangePayload(e?.target?.value, "currency_symbol_code")
                }
                placeholder="Currency Symbol Code"
              />
            </Grid>
            <Grid item>
              <FormLabel label="Description" />
              <TextInput
                value={payload?.description}
                onChange={e =>
                  handleChangePayload(e?.target?.value, "description")
                }
                placeholder="Description"
                multiline
                rows={4}
              />
            </Grid>
          </Grid>
        )}
      </DialogContent>
      <DialogActions>
        <SecondaryButton
          label="Cancel"
          disabled={loadingPage}
          onClick={onClose}
        />
        <PrimaryButton
          label={loadingButton ? "Saving" : "Save"}
          loading={loadingButton}
          disabled={loadingPage || loadingButton}
          onClick={handleSubmit}
        />
      </DialogActions>
    </Dialog>
  );
};

export default ModalFormCurrency;
